module.exports = __webpack_public_path__ + "static/media/aviso.de9f409b.png";